import React from "react";
import styles from "../styles/Thank-you.module.css";
import HeroImage from '../assets/Exited.2a704851cbd51063dc3d.png';

const HeroSection: React.FC = () => {
  return (
    <section className={styles.heroSection}>
      <div className={styles.heroContent}>
        <div className={styles.heroTextColumn}>
          <h1 className={styles.heroTitle}>
            <span className={styles.heroTitleText}>
              THANK YOU FOR JOINING THE
            </span>
            <span className={styles.heroTitleText}>UE COMIX COMMUNITY!</span>
          </h1>
        </div>

      </div>
              <div className={styles.heroImageColumn}>
          <img
            src={HeroImage}
            alt="Hero Image"
            className={styles.heroImage}
          />
        </div>
    </section>
  );
};

export default HeroSection;
